import * as React from "react";

function SvgQuestionCircleDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25z"
        />
        <path
          fill="#98DB69"
          d="M12 3.75a8.25 8.25 0 110 16.5 8.25 8.25 0 010-16.5zm0 11.125a.875.875 0 10.875.875l-.002-.024-.005-.086a.876.876 0 00-.758-.758zm.027-7.628l-.168.004c-1.336-.059-2.585.893-2.904 2.265a.75.75 0 101.461.34 1.43 1.43 0 011.317-1.106h.136l.145-.002c.763.028 1.343.583 1.387 1.299 0 .271-.179.535-.66.945l-.14.115-.365.295-.171.144c-.53.461-.815.88-.815 1.454a.75.75 0 001.5 0l.003-.011.012-.02.049-.063.092-.096.144-.132.032-.028.034-.029.337-.273.27-.223c.792-.676 1.177-1.256 1.177-2.125-.093-1.513-1.27-2.662-2.706-2.748l-.167-.005z"
        />
      </g>
    </svg>
  );
}

export default SvgQuestionCircleDuo;
